<template>
  <div
    :id="`vendor-assessment-external-advance-modal-section-1-${checklistItemId}`"
    class="tw-flex tw-flex-col tw-h-fit tw-p-3 tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1] md:tw-p-10"
    @mouseover="onHoverIn"
    @mouseout="onHoverOut"
  >
    <p
      class="tw-mb-[40px] tw-text-[25px] tw-text-[#211F58] tw-font-semibold tw-leading-[25px]"
    >
      <span
        >{{ getComponentUiText("app-component-assessments-advanced-title-1") }}
      </span>
    </p>
    <div>
      <div class="">
        <div class="tw-flex tw-w-full tw-gap-[10px] tw-items-center">
          <StatusBadge
            :label="checklistItemData.checklistItemCategoryLabel"
            class="tw-w-fit"
            :value="isExclude ? statusCode.disable : statusCode.category"
          />
        </div>
        <div
          class="tw-mt-[12px] tw-mb-[20px] tw-w-full tw-flex tw-items-center tw-justify-between"
        >
          <div
            :class="`tw-flex tw-items-center tw-pr-[10px] ${
              isExclude ? 'tw-text-[#231F20]' : 'tw-text-[#211F58]'
            }`"
          >
            <span
              :class="`tw-font-normal tw-text-[16px] ${
                isExclude ? 'tw-opacity-50' : ''
              }`"
              >{{ checklistItemData.checklistItemName }}</span
            >
            <div
              v-if="checklistItemData.checklistItemDescription"
              class="tw-pl-[25px] tw-mb-[2px]"
            >
              <ButtonShowDuplicateAssessment
                :id-popover="'popover-assessment-advanced-checklist-item-description'"
                :custom-class="'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
                :classes="`!tw-leading-none `"
              >
                <CustomDescriptionContent
                  :description="checklistItemData.checklistItemDescription"
                >
                </CustomDescriptionContent>
              </ButtonShowDuplicateAssessment>
            </div>
          </div>
        </div>

        <div>
          <AssessmentAnswerType1
            v-if="
              checklistItemData.checklistItemComplianceTypeId ===
              COMPLIANCE_TYPE.YES_NO
            "
            :id="`popover-assessment-advanced-answer-type-1-${checklistItemId}`"
            :value="selected"
            :class="[isExclude ? 'tw-opacity-50' : '']"
            :on-hover="true"
            :disabled="
              isChecklistCompleted || isExclude || !isCheckStatusInprogAndWait
            "
            :excluded="isExclude"
            @on-update="handleAnswerYesNoQuestion"
          />
          <WYSiwygEditor
            v-if="
              checklistItemData.checklistItemComplianceTypeId ===
              COMPLIANCE_TYPE.TEXT
            "
            v-model="checklistNotes"
            :include-image="false"
            :disabled="isChecklistCompleted || !isCheckStatusInprogAndWait"
            @update:value="(value) => (checklistNotes = value)"
            @update:blur="handleAnswerTextQuestion"
          />
        </div>
      </div>
    </div>
  </div>
  <div
    :id="`vendor-assessment-external-advance-modal-section-2-${checklistItemId}`"
    class="tw-flex tw-flex-col tw-h-full md:tw-p-10 tw-p-3 tw-bg-[#FCFCFD]"
  >
    <!-- Note -->
    <div class="tw-mb-[30px]">
      <p class="tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold">
        {{
          checklistItemData.checklistItemComplianceTypeId ===
          COMPLIANCE_TYPE.TEXT
            ? getComponentUiText(
                "app-component-vendor-advance-modal-answer-title-1",
              )
            : getComponentUiText(
                "app-component-assessments-override-question-note-title-1",
              )
        }}
      </p>
      <textarea
        :id="`vendor-assessment-external-advance-modal-notes-${checklistItemId}`"
        ref="autoTextarea"
        v-model="noteData"
        :class="`${
          isCheckStatusInprogAndWait ? '' : 'tw-pointer-events-none'
        } `"
        class="auto-expand tw-min-h-[px] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1]"
        :placeholder="
          isChecklistCompleted
            ? ''
            : getComponentUiText(
                'app-component-assessments-override-question-note-prompt-1',
              )
        "
        :style="`outline-color : #EFF0F1`"
        @focusout="handleUpdateNoteAssessement"
        @input="autoResize"
      ></textarea>
    </div>

    <!-- Evidence -->
    <div class="tw-mb-[30px]">
      <div class="tw-flex tw-items-center tw-justify-between">
        <p
          class="tw-mb-[10px] tw-text-[#211F58] tw-text-[15px] tw-font-semibold"
        >
          {{
            getComponentUiText(
              "app-component-vendor-advance-modal-attach-block-title-1",
            )
          }}
        </p>
        <p
          v-if="
            isCheckStatusInprogAndWait &&
            questionData.checklistItemAttachments?.length === 0 &&
            checklistType === 'reviewChecklist'
          "
          class="tw-text-[13px] tw-mb-[10px] tw-text-[#387DFF] tw-cursor-pointer tw-underline tw-leading-[145%] tw-font-normal"
        ></p>
        <p
          v-else
          class="tw-text-[13px] tw-mb-[10px] tw-text-[#387DFF] tw-cursor-pointer tw-underline tw-leading-[145%] tw-font-normal"
          @click="openEvidence"
        >
          {{
            getComponentUiText(
              "app-component-assessments-evidence-button-manage-title-1",
            )
          }}
        </p>
      </div>
      <div
        class="tw-px-[20px] tw-py-[18px] tw-bg-white tw-rounded-md tw-border-solid tw-border-[1px] tw-border-[#EFF0F1]"
      >
        <p
          v-if="questionData.checklistItemAttachments?.length === 0"
          class="tw-m-0 tw-text-[13px] tw-text-[#b7b7b7]"
        >
          {{ getComponentUiText("app-assessment-notify-notes-empty-1") }}
        </p>
        <AssessmentAdditionalInfo
          v-for="(
            { type, attachments, text, href }, index
          ) in questionData.additionalData as any"
          :id="`vendor-assessment-external-advance-add-info-${checklistItemId}`"
          :key="index"
          :type="type"
          :attachments="attachments || []"
          :text="text ? text : ''"
          :href="href ? href : ''"
          :checklist-item-id="questionData.checklistItemId"
          :is-hovered="onHover"
          :max-shown="attachments.length"
          :class-name-attachment="'tw-flex tw-flex-col tw-gap-[10px]'"
          :passkey-question="passkeyQuestion"
          :is-vendor-request="checklistType"
          :attachment-id="`vendor-assessment-external-advance-attachment-${checklistItemId}`"
          :previous-answered-id="`vendor-assessment-external-advance-previous-answered-${checklistItemId}`"
          @view-attachments="() => emit('close')"
        />
      </div>
    </div>
  </div>
  <div class="tw-justify-end tw-w-full tw-flex tw-pb-[15px] tw-pr-[40px]">
    <span
      class="tw-text-[#B7B7B7] tw-font-[Poppins] tw-text-[13px] tw-leading-normal"
      >ID: {{ checklistItemData.checklistItemId }} ({{
        checklistItemData.itemMasterId
      }})</span
    >
  </div>
</template>

<script setup lang="ts">
import {
  assessmentAnswerType1State,
  CHECKLIST_TYPE,
  COMPLIANCE_TYPE,
  TYPE_MODAL_SECURING_EVIDENCE,
} from "@/utils/constants";
import { IAssessmentChecklistItem } from "@/interfaces/assessments/IAssessmentDetails";
import {
  MODAL_NAME,
  assessmentAdditionalInfoType,
  assessmentQuestionVisibleState,
  checklistStatusId,
  statusCode,
} from "@/utils/constants";
import {
  getComponentUiText,
  getPasswordDefaultVendorAttachment,
} from "@/utils/utilities";
import { PropType, Ref, computed, onMounted, ref } from "vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import AssessmentAnswerType1 from "../assessments/assessmentAnswerType1.vue";
import store from "@/store";
import StatusBadge from "../common/setting/statusBadge.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";
import AssessmentAdditionalInfo from "../assessments/assessmentAdditionalInfo.vue";
import { IModalMessage } from "@/interfaces/common/common";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { decryptFileBase64 } from "@/utils/cipher";
import eventEmitter from "@/utils/eventEmitter";
const props = defineProps({
  questionData: {
    type: Object as PropType<IAssessmentChecklistItem>,
    default: () => ({}),
    required: true,
  },
  checklistId: {
    type: Number,
    default: 0,
  },
  checklistItemId: {
    type: Number,
    default: 0,
  },
  show: {
    type: Boolean,
    default: false,
  },
  checklistType: {
    type: String,
    default: "",
  },
  passkey: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["show", "close"]);
const selected: any = ref(props.questionData.checklistItemComplianceTypeValue);
const passkeyQuestion = ref(props.passkey);
const isCallApiGetImg = ref(false);
const checklistNotes: Ref<string> = ref(props.questionData.checklistItemNotes);
const originalChecklistNotes: Ref<string> = ref(
  props.questionData.checklistItemNotes,
);

const noteData: Ref<string> = ref(
  props.questionData.checklistItemComplianceTypeId === COMPLIANCE_TYPE.TEXT
    ? props.questionData.checklistItemCompensatingControlDescription
    : props.questionData.checklistItemNotes,
);
const originalNoteData: Ref<string> = ref(
  props.questionData.checklistItemComplianceTypeId === COMPLIANCE_TYPE.TEXT
    ? props.questionData.checklistItemCompensatingControlDescription
    : props.questionData.checklistItemNotes,
);
const autoTextarea = ref<HTMLTextAreaElement | null>(null);

const isCheckStatusInprogAndWait = computed(() =>
  props.checklistType === CHECKLIST_TYPE.externalChecklist
    ? store.getters["Vendor/isCheckStatusInprogAndWait"]
    : store.getters["Vendor/isChecklistReviewStatusInprogAndWait"],
);

const checklistItemData = ref(props.questionData);
const checklistVendorRequestedExternalInput = computed(() => {
  return props.checklistType === CHECKLIST_TYPE.externalChecklist
    ? store.state.Vendor.checklistVendorRequestedExternalInput
    : store.state.Vendor.requestedDetailItem?.checklistsRequested[0];
});
const providerId = computed(() =>
  props.checklistType === CHECKLIST_TYPE.externalChecklist
    ? store.state.Vendor.checklistVendorRequestedExternalInput.providerId
    : store.state.Vendor.requestedDetailItem?.checklistsRequested[0].providerId,
);

const isExclude = computed(() => {
  return (
    checklistItemData.value.visibleState === assessmentQuestionVisibleState.no
  );
});

const isChecklistCompleted = computed(() => {
  const checklistRequested = checklistVendorRequestedExternalInput.value;
  return checklistRequested.statusId === checklistStatusId.completed;
});
const onHover = ref(false);
let setTimeOutRef: any = null;

const onHoverIn = () => {
  if (setTimeOutRef) clearTimeout(setTimeOutRef);
  onHover.value = true;
};

const onHoverOut = () => {
  setTimeOutRef = setTimeout(() => {
    onHover.value = false;
  }, 150);
};

const checkPasswordConfirm = async (attachmentId, password) => {
  isCallApiGetImg.value = true;
  const res =
    props.checklistType === CHECKLIST_TYPE.externalChecklist
      ? await store.dispatch(
          "Vendor/fetchVendorRequestedExternalAttachment",
          attachmentId,
        )
      : await store.dispatch(
          "Vendor/fetchVendorRequestedAttachment",
          attachmentId,
        );
  const file = await decryptFileBase64(res.data.data, password);
  isCallApiGetImg.value = false;
  return file ? res : false;
};

const openSecuringModal = (attachmentId: number | null, type) => {
  const emitData = {
    component: MODAL_NAME.MODAL_SECURING_EVIDENCE,
    properties: {
      type,
      attachmentId,
      isVendorRequest: props.checklistType,
      checklistItemId: props.checklistItemId,
      styleClass: { background: "rgba(0, 0, 0, 0.5)", top: "0px" },
    },
    events: {
      "update:data": (passkey) => {
        passkeyQuestion.value = passkey;
        openEvidenceModal();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const openEvidence = async () => {
  const attachments: any = props.questionData.additionalData?.filter(
    (i: any) => i.type === assessmentAdditionalInfoType.attachment,
  );
  if (
    !passkeyQuestion.value &&
    props.questionData.checklistItemAttachments?.length
  ) {
    const check = await checkPasswordConfirm(
      attachments[0]?.attachments[0]?.attachmentId,
      getPasswordDefaultVendorAttachment(providerId.value),
    );
    if (check) {
      eventEmitter.emit(EmitterEvents.UPDATE_PASSWORD_ASSESSMENT_QUESTION, {
        checklistItemId: props.checklistItemId,
        password: getPasswordDefaultVendorAttachment(providerId.value),
      });
      passkeyQuestion.value = getPasswordDefaultVendorAttachment(
        providerId.value,
      );
    } else {
      openSecuringModal(
        attachments[0]?.attachments[0]?.attachmentId,
        TYPE_MODAL_SECURING_EVIDENCE.DECRYPT,
      );
      return;
    }
  }
  openEvidenceModal();
};

const openEvidenceModal = () => {
  const attachments: any = props.questionData.additionalData?.filter(
    (i: any) => i.type === assessmentAdditionalInfoType.attachment,
  );
  if (isChecklistCompleted.value) return;

  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_EVIDENCE,
    properties: {
      value: {
        questionTitle: `${props.questionData.checklistItemName}${
          props.questionData.subName ? ` | ${props.questionData.subName}` : ""
        }`,
        subCategory:
          props.questionData.checklistItemHeadingLabel ||
          props.questionData.checklistItemName ||
          "",
        category: props.questionData.checklistItemCategoryLabel,
        checklistId:
          checklistVendorRequestedExternalInput.value.checklistRequestedId,
        checklistItemId: props.questionData.checklistItemId,
      },
      dataTableFile: attachments
        ? attachments[0]?.attachments?.map((item) => {
            return { ...item, id: item.attachmentId };
          })
        : [],
      passkey: passkeyQuestion.value,
      isVendorRequest: props.checklistType,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleUpdateNoteAssessement = async (e) => {
  const updataObj = {
    checklistRequestedItemId: props.questionData.checklistItemId,
  };

  if (
    checklistItemData.value.checklistItemComplianceTypeId ===
    COMPLIANCE_TYPE.TEXT
  ) {
    updataObj["compensatingControlDescription"] = e.target.value;
  } else {
    updataObj["notes"] = e.target.value;
  }

  if (originalNoteData.value !== noteData.value) {
    const result =
      props.checklistType === CHECKLIST_TYPE.externalChecklist
        ? await store.dispatch("Vendor/updateVendorRequestedExternalInput", [
            updataObj,
          ])
        : await store.dispatch("Vendor/updateRequestedItems", {
            id: props.checklistId,
            values: [updataObj],
          });

    if (result) originalNoteData.value = noteData.value;
    else noteData.value = originalNoteData.value;
  }
};

const handleAnswerTextQuestion = async () => {
  if (originalChecklistNotes.value !== checklistNotes.value) {
    const result =
      props.checklistType === CHECKLIST_TYPE.externalChecklist
        ? await store.dispatch("Vendor/updateVendorRequestedExternalInput", [
            {
              checklistRequestedItemId: props.questionData.checklistItemId,
              notes: checklistNotes.value,
            },
          ])
        : await store.dispatch("Vendor/updateRequestedItems", {
            id: props.checklistId,
            values: [
              {
                notes: checklistNotes.value,
                checklistRequestedItemId: props.checklistItemId,
              },
            ],
          });

    if (result) originalChecklistNotes.value = checklistNotes.value;
    else checklistNotes.value = originalChecklistNotes.value;
  }
};

const answerId = {
  1: assessmentAnswerType1State.no,
  2: assessmentAnswerType1State.yes,
};
const handleAnswerYesNoQuestion = async (answer: any) => {
  const answerKey = Object.keys(answerId).find((k) => answerId[k] === answer);

  if (!answerKey) return;

  selected.value = answer;
  props.checklistType === CHECKLIST_TYPE.externalChecklist
    ? await store.dispatch("Vendor/updateVendorRequestedExternalInput", [
        {
          checklistRequestedItemId: props.questionData.checklistItemId,
          complianceTypeValueId: answerKey,
        },
      ])
    : await store.dispatch("Vendor/updateRequestedItems", {
        id: props.checklistId,
        values: [
          {
            complianceTypeValueId: answerKey,
            checklistRequestedItemId: props.checklistItemId,
          },
        ],
      });
};

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "1.5rem"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

onMounted(() => {
  autoResize();
});
</script>
<style lang="scss" scoped>
.gray-dropdown-containe {
  .btn-secondary {
    padding: 12px;
  }
}
.disable-text {
  color: #231f20;
}
.auto-expand {
  width: 100%;
  overflow-y: hidden;
  resize: none;
  outline-color: #eff0f1;
  line-height: 18px;
  color: #231f20;
}

textarea::placeholder {
  color: #b7b7b7;
  font-size: 13px;
}

:deep(.popover-body) {
  padding: 8px 14px !important;
}
</style>
